import { Box, Button, Modal, Text } from "@modernatx-internal/component-library";
import React from "react";

import { useTextBlockRendering } from "@/components/TextBlock/TextBlockRenderContext";
import { useExitModal } from "@/hooks/useExitModal";

import { ContentComponentProps, ExitModalContent } from "../types";

export const ExitModal: React.FC<ContentComponentProps<ExitModalContent>> = ({
  buttonText,
  children,
  finderChildren,
  title
}) => {
  const { isExitModalVisible, openExitModal, exitLink, exitReason } = useExitModal();
  const { editing } = useTextBlockRendering();
  const bodyChildren = exitReason === "finder" && finderChildren ? finderChildren : children;

  return (
    <Modal
      // @ts-ignore
      title={
        <Text as="h3" variant={["h5", null, "h4"]}>
          {title}
        </Text>
      }
      isOpen={isExitModalVisible}
      onDismiss={() => openExitModal(false)}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 4
        }}
      >
        {bodyChildren}
        <Box>
          <Button
            // The data-exiting-link attribute is needed so we can allow this link to exit
            data-exiting-link={true}
            href={editing ? undefined : exitLink}
            icon="arrow-up-right"
            iconPosition="end"
            size="lg"
            target="_blank"
          >
            {/* @ts-ignore */}
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
